import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppInformationService, BrewersUnitOfWork } from '../../core/core.module';
import _ from 'lodash';
import { confirm, alert } from 'devextreme/ui/dialog';
import { isDate } from 'lodash';

@Component({
    standalone: false,
    selector: 'app-date-dialog',
    templateUrl: './date-dialog.component.html',
    styleUrls: ['./date-dialog.component.scss'],
})
export class DateDialogComponent implements OnInit, AfterViewInit {
    result: Subject<any> = new Subject<any>();
    dialogHeader: string;
    dialogPrompt: string;
    dialogMessage: string;
    dialogValue: any;
    required = true as boolean;
    processing = false;

    @ViewChild('dateComponent') dateComponent: any;

    constructor(public modalRef: BsModalRef, private uow: BrewersUnitOfWork, private appInfo: AppInformationService) { }

    async ngOnInit() { }

    ngAfterViewInit() {
        setTimeout(() => {
            this.dateComponent.instance.focus();
        });
    }

    onInput(e: any) { }

    enterPressed() {
        this.save();
    }

    save() {
        if (this.required && !isDate(this.dialogValue)) {
            alert('Value needs to be a date', `${this.appInfo.settings.company}`);
            return;
        }
        this.processing = true;
        this.result.next({ success: true, value: this.dialogValue });
    }

    cancel() {
        this.result.next({ success: false });
    }
}
